import React, { useEffect, useRef } from 'react';

import { StyledMenu } from './Menu.styles';

import { menuDefaultProps } from './Menu.defaultProps';

import { MenuProps } from './Menu.types';

import { MenuItemList } from './MenuItemList';

const Menu = ({
  isOpen,
  handleClose,
  display = 'mobile',
  menuItemList,
  componentClassname = 'menu',
  customClassnames = '',
  customStyle = '',
  hasMobileOverlay = true,
  beforeMenuSlot,
  afterMenuSlot,
  renderLink,
  currentLocationPath,
  wayToDisplayChildrenByDropdown = menuDefaultProps.wayToDisplayChildrenByDropdown,
  areChildrenDisplayedByDropdown = menuDefaultProps.areChildrenDisplayedByDropdown,
  toggleSlot = menuDefaultProps.toggleSlot,
  currentPageLabel = menuDefaultProps.currentPageLabel,
  onOpenSubMenu = menuDefaultProps.onOpenSubMenu,
  onCloseSubMenu = menuDefaultProps.onCloseSubMenu,
}: MenuProps) => {
  const menuRef = useRef<HTMLElement>();
  const menuItemListRef = useRef(null);

  useEffect(() => {
    if (!isOpen) {
      closeAllSubMenu();
    }
  }, [isOpen]);

  /**
   * Manage click outside of component
   */
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        closeAllSubMenu();
      }
    }

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const closeAllSubMenu = () => {
    if (menuItemListRef.current) {
      menuItemListRef.current.closeSubMenu();
    }
  };

  return (
    <StyledMenu
      className={`${componentClassname} ${componentClassname}--display-${display} ${
        isOpen ? `${componentClassname}--is-open` : ''
      } ${customClassnames ? customClassnames : ''}`}
      customStyle={customStyle}
      ref={menuRef}
      aria-label="Menu"
    >
      {hasMobileOverlay && display === 'mobile' && (
        <div
          className={`${componentClassname}__overlay`}
          onClick={handleClose}
        ></div>
      )}

      <div className={`${componentClassname}__inner`}>
        {beforeMenuSlot && (
          <span className={`${componentClassname}__before-content`}>
            {beforeMenuSlot}
          </span>
        )}
        {menuItemList &&
          menuItemList.itemList &&
          menuItemList.itemList?.length && (
            <MenuItemList
              ref={menuItemListRef}
              itemList={menuItemList.itemList}
              display={display}
              wayToDisplayChildrenByDropdown={wayToDisplayChildrenByDropdown}
              renderLink={renderLink}
              currentLocationPath={currentLocationPath}
              areChildrenDisplayedByDropdown={
                menuItemList.areChildrenDisplayedByDropdown ??
                areChildrenDisplayedByDropdown
              }
              customClassnames={`${componentClassname}__item-list ${
                menuItemList.customClassnames && menuItemList.customClassnames
              }`}
              currentPageLabel={
                menuItemList.currentPageLabel ?? currentPageLabel
              }
              toggleSlot={menuItemList.toggleSlot ?? toggleSlot}
              onOpenSubMenu={menuItemList.onOpenSubMenu ?? onOpenSubMenu}
              onCloseSubMenu={menuItemList.onCloseSubMenu ?? onCloseSubMenu}
            />
          )}
        {afterMenuSlot && (
          <span className={`${componentClassname}__after-content`}>
            {afterMenuSlot}
          </span>
        )}
      </div>
    </StyledMenu>
  );
};
Menu.displayName = 'Menu';

export default Menu;
